/* ORION Liquid Buttons — RESET v3 JS
   - cursor highlight vars: --mx/--my
   - optional wobble before navigation
   - optional click delay before navigation
   - safer: never blocks submit/payment/JS-only buttons
*/
(() => {
  const root = document.documentElement;
  if (root.getAttribute('data-orion-liquid') !== 'true') return;

  // The owner's rule: this motion plays also when the system asks for reduced motion. The theme setting "Respect prefers-reduced-motion" no longer switches it off.
  const allowMotion = true;

  const all = root.getAttribute('data-orion-liquid-all') === 'true';

  const selector = all
    ? [
        '.button',
        'button.button',
        'input.button',
        'input[type="submit"]',
        'button[type="submit"]',
        '.product-form__submit',
        'button[name="add"]',
        '.shopify-payment-button__button',
        'a.button',
        'a.link.animate-arrow',
        '.multicolumn-card__info a.link',
        '.slideshow__text a',
        '.slideshow__text .button',
        '.banner__buttons a',
        '.banner__buttons .button',
        'a.box.orion-cta',
      ].join(', ')
    : '.orion-liquid';

  const cssVar = (name) => getComputedStyle(root).getPropertyValue(name).trim().replace(/"/g, '');

  const getDelay = () => {
    const v = cssVar('--orion-liquid-click-delay');
    const n = parseInt(v.replace('ms', ''), 10);
    return Number.isFinite(n) ? n : 0;
  };

  const getWobble = () => cssVar('--orion-liquid-wobble') || 'subtle';

  const addPointerVars = (el, ev) => {
    const r = el.getBoundingClientRect();
    const x = ((ev.clientX - r.left) / r.width) * 100;
    const y = ((ev.clientY - r.top) / r.height) * 100;
    el.style.setProperty('--mx', `${x}%`);
    el.style.setProperty('--my', `${y}%`);
  };

  const bindHover = (el) => {
    el.addEventListener('pointermove', (ev) => addPointerVars(el, ev), { passive: true });
  };

  const isPaymentButton = (el) => el.classList && el.classList.contains('shopify-payment-button__button');
  const isSubmit = (el) => {
    const tag = el.tagName;
    if (tag === 'INPUT') return (el.type || '').toLowerCase() === 'submit';
    if (tag === 'BUTTON') return ((el.type || el.getAttribute('type') || '').toLowerCase() === 'submit');
    return false;
  };

  const bindClick = (el) => {
    el.addEventListener('click', (ev) => {
      if (!allowMotion) return;

      // Never interfere with submit/payment buttons
      if (isPaymentButton(el) || isSubmit(el)) return;

      const delay = getDelay();
      const wobble = getWobble();
      if ((delay <= 0) && (wobble === 'off')) return;

      // Only intercept REAL navigation anchors (not JS-only buttons)
      const link = el.tagName === 'A' ? el : el.closest('a[href]');
      const href = link?.getAttribute('href');

      if (!href) return;
      if (href.startsWith('#') || href.startsWith('javascript:')) return;
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button === 1) return;

      // If the clicked element is not the anchor itself and anchor is inside complex widgets,
      // do not prevent unless it's clearly a CTA button.
      // (keeps Shopify widgets safe)
      if (el.tagName !== 'A' && !el.classList.contains('button') && !el.classList.contains('orion-liquid')) return;

      ev.preventDefault();

      if (wobble !== 'off') {
        el.classList.add('orion-liquid--wobble');
        setTimeout(() => el.classList.remove('orion-liquid--wobble'), wobble === 'medium' ? 220 : 160);
      }

      window.setTimeout(() => window.location.assign(href), Math.max(0, delay));
    }, { capture: true });
  };

  const init = () => {
    document.querySelectorAll(selector).forEach((el) => {
      // Skip if already bound (prevents duplicate listeners on section reload)
      if (el.__orionLiquidBound) return;
      el.__orionLiquidBound = true;

      bindHover(el);
      bindClick(el);
    });
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
